(ns web3.persistence.current-property
  (:require [web3.utils :as utils]
            [web3.persistence.queries :as q]
            [web3.persistence.local :as local]
            [re-frame-simple.db :as db]
            [web3.queries.root :as q-root]))

(local/init-storage [:current-property-id])

(defn get-id
  ([] (get-id nil))
  ([property-id]
   (let [cached-id (db/get :current-property-id)
         route-id (db/get-in [:db/routers :router/root :route-params :property-id])]
     (or property-id
         route-id
         cached-id))))

(defn get-property
  "Get current property.

  If `id` is provided, attempts to load that property; defaults to first property in the list."
  ([] (get-property nil))
  ([property-id]
   (let [id (get-id property-id)
         properties (->> (q-root/me)
                         :me
                         :propertyRights
                         (map :property))]
     (if id
       (or (utils/find-first #(= (:id %) id) properties)
           (first properties))
       (first properties)))))